export default "__VITE_ASSET__CVlZwN6Z__"